import { useState } from 'react';
import { useUnmount } from 'react-use';
import { RefState } from './useRefState';

const useStateFromRefState = <T>(ref: RefState<T>, handlerIdentifier: string): T | null => {
  const [stateValue, setStateValue] = useState(ref.current.value);

  // it's okay to set this on every render, because the ref is stable
  // it needs to happen outside of a useEffect because useEffects are run asynchronously
  // so other useEffects might call the handler before the handler is set
  ref.current.onUpdate(handlerIdentifier, setStateValue);

  useUnmount(() => {
    ref.current.onUpdate(handlerIdentifier, null);
  });

  return stateValue;
};

export default useStateFromRefState;
